module.exports = require("./../../_gen/starling/textures/AtfData");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/textures/AtfData.js
// module id = 233
// module chunks = 0